import { PlusIcon } from '@heroicons/react/24/outline';
import { Button } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { SearchEntity } from '../../../server/types/search-types.ts';
import { useCustomerBasis } from '../../customer-detail/hooks/use-customer-basis.ts';
import { useShowCreateTaskDialog } from '../../tasks/hooks/use-show-create-task-dialog.ts';

type Props = {
    itemTitle: string;
    customerId: string | undefined;
};

export function InventoryActions({ itemTitle, customerId }: Props) {
    const { t } = useLocale();
    const { data: customerBasics } = useCustomerBasis({ customerId });
    const showCreateTaskDialog = useShowCreateTaskDialog();

    return (
        <Button
            variant="primary"
            icon={PlusIcon}
            onClick={() => {
                showCreateTaskDialog({
                    description: itemTitle,
                    links: customerId
                        ? [
                              {
                                  modelType: SearchEntity.Customer,
                                  modelId: customerId,
                                  title: customerBasics?.customerName ?? '',
                              },
                          ]
                        : undefined,
                    source: 'inventory',
                });
            }}
        >
            {t('header__new_task', { ns: 'product-details' })}
        </Button>
    );
}
